import { render, staticRenderFns } from "./TableResolvedPetitions.vue?vue&type=template&id=44eb438c"
import script from "./TableResolvedPetitions.vue?vue&type=script&lang=js"
export * from "./TableResolvedPetitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports